module.exports = __webpack_public_path__ + "sx.svg?86cf183abda12f22953b28dcbcda7eab";